import { Grouping } from '@devexpress/dx-react-grid';
import { UpdateInvoicesActionPayload } from './rootReducerTypes';

// #region actions
export type InvoiceListActionTypes =
    UpdateInvoicesAction
    | RequestErrorAction
    | FetchInitAction
    | SetCurrentPageAction
    | UpdateQueryAction
    | SetPageSizeAction
    | UpdateShowHistoricalAction
    | UpdateOrderInvoiceStatusAction
    | UpdateOrderTypeAction
    | UpdateDateTypeAction
    | UpdateSortByAction
    | UpdateSearchInvoicesAction
    | ChangeGroupingAction
    | SetExpandedGroupsAction

export const UPDATE_INVOICES = "UPDATE_INVOICES";
export interface UpdateInvoicesAction {
    type: typeof UPDATE_INVOICES;
    updateInvoicesActionPayload: UpdateInvoicesActionPayload;
}

export const REQUEST_ERROR = "REQUEST_ERROR";
export interface RequestErrorAction {
    type: typeof REQUEST_ERROR;
}

export const FETCH_INIT = "FETCH_INIT";
export interface FetchInitAction {
    type: typeof FETCH_INIT;
}

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export interface SetCurrentPageAction {
    type: typeof SET_CURRENT_PAGE;
    currentPage: number;
}
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export interface SetPageSizeAction {
    type: typeof SET_PAGE_SIZE;
    pageSize: number;
}
export const UPDATE_QUERY = "UPDATE_QUERY";
export interface UpdateQueryAction {
    type: typeof UPDATE_QUERY;
    lastQuery: string;
}

export const UPDATE_SHOW_HISTORICAL = "UPDATE_SHOW_HISTORICAL";
export interface UpdateShowHistoricalAction {
    type: typeof UPDATE_SHOW_HISTORICAL;
    showHistorical: boolean;
}

export const UPDATE_ORDER_INVOICE_STATUS = "UPDATE_ORDER_INVOICE_STATUS";
export interface UpdateOrderInvoiceStatusAction {
    type: typeof UPDATE_ORDER_INVOICE_STATUS;
    orderInvoiceStatus: any;
}

export const UPDATE_ORDER_TYPE = "UPDATE_ORDER_TYPE";
export interface UpdateOrderTypeAction {
    type: typeof UPDATE_ORDER_TYPE;
    orderType: any;
}

export const UPDATE_DATE_TYPE = "UPDATE_DATE_TYPE";
export interface UpdateDateTypeAction {
    type: typeof UPDATE_DATE_TYPE;
    dateType: any;
}

export const UPDATE_SORTBY = "UPDATE_SORTBY";
export interface UpdateSortByAction {
    type: typeof UPDATE_SORTBY;
    sortBy: string;
}

export const UPDATE_SEARCH_INVOICES = "UPDATE_SEARCH_INVOICES";
export interface UpdateSearchInvoicesAction {
    type: typeof UPDATE_SEARCH_INVOICES;
    searchText: string;
}

export const CHANGE_GROUPING = "CHANGE_GROUPING";
export interface ChangeGroupingAction {
    type: typeof CHANGE_GROUPING,
    grouping: Grouping[]
}

export const SET_EXPANDED_GROUPS = "SET_EXPANDED_GROUPS"
export interface SetExpandedGroupsAction {
    type: typeof SET_EXPANDED_GROUPS,
    expandedGroups: string[]
}
